import { render } from "./OurEquipment.vue?vue&type=template&id=d70511fc"
import script from "./OurEquipment.vue?vue&type=script&lang=js"
export * from "./OurEquipment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__